import auth from '../auth';
import ApigClientFactory from '../apigClient';

const config = {
    invokeUrl: process.env.PA_API_URL,
    region: process.env.AWS_REGION,
    accessKey: '',
    secretKey: '',
    sessionToken: '',
    apiKey: undefined,
    defaultContentType: 'application/json',
    defaultAcceptType: 'application/json'
};
export const SearchService = {
    async query(body) {
        return post('/pa-search', body);
    },
    async queryMetrics(body) {
        return post('/pa-search/status', body);
    }
};

async function post(pathTemplate, body) {
    await auth.getCredentialsForRole(process.env.PA_ROLE_SEARCH)
        .then((credentials) => {
            config.accessKey = credentials.Credentials.AccessKeyId;
            config.secretKey = credentials.Credentials.SecretKey;
            config.sessionToken = credentials.Credentials.SessionToken;
        });

    let client = ApigClientFactory.newClient(config);

    return client.invokeApi({}, pathTemplate, 'POST', {}, body);
}



// WEBPACK FOOTER //
// ./src/services/pa/search.service.js